import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as noticeActions from '../actions/notice';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  allNotices: {
    data: [],
    state: null,
  },
  allNoticeConfig: {
    data: [],
    state: null,
  },
  noticeConfig: {
    data: {},
    state: null,
  },
  allNoticeConfigByYear: {
    data: [],
    state: null,
  },
  allNoticeConfigTaxingUnit: {
    data: [],
    state: null,
  },
  taxingUnitsSummary: {
    data: [],
    state: null,
  },
  appraisalNoticeSubmissions: {
    data: [],
    state: null,
  },
  appraisalNoticeSubmission: {
    data: {},
    state: null,
  },
  folders: {
    data: [],
    state: null,
  },
  imports: {
    data: [],
    state: null,
  },
  eventTypes: {
    data: [],
    state: null,
  },
  massCreateCompGrids: {
    data: [],
    state: null,
  },
  checkLiveRun: {
    state: null,
  },
  massFiles: {
    data: [],
    totalRecords: 0,
    state: null,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_RUN[START]: {
      return state.setIn(['allNotices', 'state'], fetchingState.FETCHING);
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_RUN[ERROR]: {
      return state.setIn(['allNotices', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_RUN[SUCCESS]: {
      return state
        .setIn(['allNotices', 'state'], fetchingState.LOADED)
        .setIn(
          ['allNotices', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.DELETE_APPRAISAL_NOTICE_RUN[SUCCESS]: {
      return state.setIn(
        ['allNotices', 'data'],
        fromJS(
          state
            .getIn(['allNotices', 'data'])
            .toJS()
            .filter((u) => u.noticeID !== action.noticeID),
        ),
      );
    }

    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_CONFIG[START]: {
      const stateField = action.pYear
        ? 'allNoticeConfigByYear'
        : 'allNoticeConfig';
      return state.setIn([stateField, 'state'], fetchingState.FETCHING);
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_CONFIG[ERROR]: {
      const stateField = action.pYear
        ? 'allNoticeConfigByYear'
        : 'allNoticeConfig';
      return state.setIn([stateField, 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_CONFIG[SUCCESS]: {
      const stateField = action.pYear
        ? 'allNoticeConfigByYear'
        : 'allNoticeConfig';
      return state
        .setIn([stateField, 'state'], fetchingState.LOADED)
        .setIn(
          [stateField, 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.INSERT_APPRAISAL_NOTICE_CONFIG[SUCCESS]: {
      return state
        .setIn(
          ['allNoticeConfig', 'data'],
          fromJS(
            state
              .getIn(['allNoticeConfig', 'data'])
              .toJS()
              .concat(_.get(action, ['data', 'results'], [])),
          ),
        )
        .setIn(['noticeConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['noticeConfig', 'data'],
          fromJS(_.get(action, ['data', 'results', '0'], {})),
        );
    }

    case noticeActions.DELETE_APPRAISAL_NOTICE_CONFIG[SUCCESS]: {
      return state.setIn(
        ['allNoticeConfig', 'data'],
        fromJS(
          state
            .getIn(['allNoticeConfig', 'data'])
            .toJS()
            .filter((c) => c.configID !== action.configID),
        ),
      );
    }

    case noticeActions.FETCH_APPRAISAL_NOTICE_CONFIG[SUCCESS]: {
      return state
        .setIn(['noticeConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['noticeConfig', 'data'],
          fromJS(_.get(action, ['data', 'results', '0'], {})),
        );
    }

    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[START]: {
      return state.setIn(
        ['allNoticeConfigTaxingUnit', 'state'],
        fetchingState.FETCHING,
      );
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[ERROR]: {
      return state.setIn(
        ['allNoticeConfigTaxingUnit', 'state'],
        fetchingState.ERROR,
      );
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[SUCCESS]: {
      return state
        .setIn(['allNoticeConfigTaxingUnit', 'state'], fetchingState.LOADED)
        .setIn(
          ['allNoticeConfigTaxingUnit', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.INSERT_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[SUCCESS]: {
      return state.setIn(
        ['allNoticeConfigTaxingUnit', 'data'],
        fromJS(
          state
            .getIn(['allNoticeConfigTaxingUnit', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    }

    case noticeActions.DELETE_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[SUCCESS]: {
      return state.setIn(
        ['allNoticeConfigTaxingUnit', 'data'],
        fromJS(
          state
            .getIn(['allNoticeConfigTaxingUnit', 'data'])
            .toJS()
            .filter((u) => u.configID !== action.configID),
        ),
      );
    }

    case noticeActions.FETCH_TAXING_UNITS_SUMMARY[START]: {
      return state.setIn(
        ['taxingUnitsSummary', 'state'],
        fetchingState.FETCHING,
      );
    }
    case noticeActions.FETCH_TAXING_UNITS_SUMMARY[ERROR]: {
      return state.setIn(['taxingUnitsSummary', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_TAXING_UNITS_SUMMARY[SUCCESS]: {
      return state
        .setIn(['taxingUnitsSummary', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingUnitsSummary', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS[START]: {
      return state.setIn(
        ['appraisalNoticeSubmissions', 'state'],
        fetchingState.FETCHING,
      );
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS[ERROR]: {
      return state.setIn(
        ['appraisalNoticeSubmissions', 'state'],
        fetchingState.ERROR,
      );
    }
    case noticeActions.FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS[SUCCESS]: {
      return state
        .setIn(['appraisalNoticeSubmissions', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisalNoticeSubmissions', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.FETCH_APPRAISAL_NOTICE_SUBMISSION[START]: {
      return state.setIn(
        ['appraisalNoticeSubmission', 'state'],
        fetchingState.FETCHING,
      );
    }
    case noticeActions.FETCH_APPRAISAL_NOTICE_SUBMISSION[ERROR]: {
      return state.setIn(
        ['appraisalNoticeSubmission', 'state'],
        fetchingState.ERROR,
      );
    }
    case noticeActions.FETCH_APPRAISAL_NOTICE_SUBMISSION[SUCCESS]: {
      return state
        .setIn(['appraisalNoticeSubmission', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisalNoticeSubmission', 'data'],
          fromJS(_.get(action, ['data', 'results', '0'], {})),
        );
    }

    case noticeActions.FETCH_FOLDERS[START]: {
      return state.setIn(['folders', 'state'], fetchingState.FETCHING);
    }
    case noticeActions.FETCH_FOLDERS[ERROR]: {
      return state.setIn(['folders', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_FOLDERS[SUCCESS]: {
      return state
        .setIn(['folders', 'state'], fetchingState.LOADED)
        .setIn(['folders', 'data'], fromJS(_.get(action, ['data'], [])));
    }

    case noticeActions.FETCH_IMPORTS[START]: {
      return state.setIn(['imports', 'state'], fetchingState.FETCHING);
    }
    case noticeActions.FETCH_IMPORTS[ERROR]: {
      return state.setIn(['imports', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_IMPORTS[SUCCESS]: {
      return state
        .setIn(['imports', 'state'], fetchingState.LOADED)
        .setIn(
          ['imports', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.IMPORT_NOTICE[SUCCESS]: {
      return state.setIn(
        ['imports', 'data'],
        fromJS(
          state
            .getIn(['imports', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    }

    case noticeActions.FETCH_EVENT_TYPES[START]: {
      return state.setIn(['eventTypes', 'state'], fetchingState.FETCHING);
    }
    case noticeActions.FETCH_EVENT_TYPES[ERROR]: {
      return state.setIn(['eventTypes', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_EVENT_TYPES[SUCCESS]: {
      return state
        .setIn(['eventTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventTypes', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case noticeActions.FETCH_MASS_CREATE_COMP_GRIDS[START]: {
      return state.setIn(
        ['massCreateCompGrids', 'state'],
        fetchingState.FETCHING,
      );
    }
    case noticeActions.FETCH_MASS_CREATE_COMP_GRIDS[ERROR]: {
      return state.setIn(['massCreateCompGrids', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_MASS_CREATE_COMP_GRIDS[SUCCESS]: {
      return state
        .setIn(['massCreateCompGrids', 'state'], fetchingState.LOADED)
        .setIn(['massCreateCompGrids', 'data'], fromJS(action.data));
    }

    case noticeActions.LOCK_PROPERTY[SUCCESS]:
    case noticeActions.CREATE_PDF_EVENTS[SUCCESS]: {
      return state.setIn(
        ['allNotices', 'data'],
        fromJS(
          state
            .getIn(['allNotices', 'data'])
            .toJS()
            .map((v) =>
              v.noticeID === action.noticeID ? action.data.results[0] : v,
            ),
        ),
      );
    }

    case noticeActions.CHECK_LIVE_RUN[START]: {
      return state.setIn(['checkLiveRun', 'state'], fetchingState.FETCHING);
    }
    case noticeActions.CHECK_LIVE_RUN[SUCCESS]: {
      return state.setIn(['checkLiveRun', 'state'], fetchingState.LOADED);
    }
    case noticeActions.CHECK_LIVE_RUN[ERROR]: {
      return state.setIn(['checkLiveRun', 'state'], fetchingState.ERROR);
    }

    case noticeActions.FETCH_IMPORT_MASS_FILES[START]: {
      return state.setIn(['massFiles', 'state'], fetchingState.FETCHING);
    }
    case noticeActions.FETCH_IMPORT_MASS_FILES[ERROR]: {
      return state.setIn(['massFiles', 'state'], fetchingState.ERROR);
    }
    case noticeActions.FETCH_IMPORT_MASS_FILES[SUCCESS]: {
      return state
        .setIn(['massFiles', 'state'], fetchingState.LOADED)
        .setIn(
          ['massFiles', 'data'],
          fromJS(_.get(action, ['data', 'results', 'records'], [])),
        )
        .setIn(
          ['massFiles', 'totalRecords'],
          _.get(action, 'data.results.totalRecords', 0),
        );
    }

    default:
      return state;
  }
};
